import { useEffect } from "react";
import { useVisibility } from "@/features/visibility/use-visibility";
import { useOrgGroupVisibilityRules } from "@/features/visibility/use-visibility-query";

/**
 * Dociąga reguły widoczności grupy wybranej w edytorze i wstrzykuje je do providera.
 *
 * Dlaczego osobny komponent, a nie `useQuery` w samym providerze: provider jest
 * sterowany propsami i renderowany w testach BEZ `QueryClientProvider` — wsadzenie
 * tam hooka React Query wywaliłoby je wszystkie. Ten komponent renderuje się
 * wewnątrz providera (zna `selectedGroupId`) i jednocześnie wewnątrz
 * QueryClientProvidera, więc widzi obie strony.
 *
 * Nie renderuje nic. Bez wybranej grupy nie odpala żadnego zapytania
 * (`enabled: groupId != null`).
 */
export function OrgGroupRulesSync() {
	const { selectedGroupId, setEditorGroupRules } = useVisibility();
	const { data } = useOrgGroupVisibilityRules(selectedGroupId);

	useEffect(() => {
		// Wyczyszczenie przy odznaczeniu grupy jest istotne: bez tego stare granty
		// zostałyby w mapie i po przełączeniu na rolę pokazywałyby zawyżony stan.
		setEditorGroupRules(selectedGroupId == null ? [] : (data?.data ?? []));
	}, [selectedGroupId, data, setEditorGroupRules]);

	return null;
}
